import {BANKS_SIMPLE_LIST, CONTACTS_SIMPLE_LIST} from "@/core/services/store/contacts.module";

export default {
    data() {
        return {
            paymentModes: [
                {text: 'Cash', value: 1},
                {text: 'Cheque', value: 2},
            ],
            cashableOptions: [
                {text: 'Cashable', value: 1},
                {text: 'Non-Cashable', value: 0},
            ],
            syncingReservationPricing: false,
            displaySalePrice: '',
            banksFilter: [],
            isBanksLoaded: false,
            ownersSearch: '',
        };
    },
    computed: {
        salePriceAmount() {
            if (this.displaySalePrice && this.displaySalePrice !== 'N/A') {
                return this.parseFormattedNumber(this.displaySalePrice);
            }

            const candidates = [
                this.item.reserve_sale_price,
                this.item.max_sale_price,
                this.item.min_sale_price,
                this.item.max_price_temp,
            ];

            for (const candidate of candidates) {
                const amount = this.parseFormattedNumber(candidate);
                if (amount > 0) {
                    return amount;
                }
            }

            return 0;
        },
        isChequePayment() {
            return Number(this.editedItem.mode_of_payment) === 2;
        },
        isAgencyUser() {
            return this.$store.state.auth.user.type === 3 || this.$store.state.auth.user.type === 5;
        },
        isListingEoiItem() {
            const listing = this.item || {};
            const count = listing.project && Number(listing.project.project_bank_details_count);

            return !count || count <= 0;
        },
        bookingAmountLabel() {
            return this.isListingEoiItem ? 'EOI Amount *' : 'Booking Amount *';
        },
        bookingPercentLabel() {
            return this.isListingEoiItem ? 'EOI (%) *' : 'Booking (%) *';
        },
    },
    watch: {
        'editedItem.mode_of_payment'(value) {
            if (Number(value) !== 2) {
                this.clearChequeFields();
            } else {
                this.loadBanksList();
            }
        },
    },
    methods: {
        clearChequeFields() {
            this.$set(this.editedItem, 'cheque_number', '');
            this.$set(this.editedItem, 'bank_name', '');
            this.$set(this.editedItem, 'cheque_date', '');
            this.$set(this.editedItem, 'is_cashable', null);
        },
        banksFilterKeyUp(e) {
            clearTimeout(this.bankApiTimeout);
            const that = this;
            this.bankApiTimeout = setTimeout(function () {
                that.loadBanksList(e.target.value || '');
            }, 300);
        },
        loadBanksList(query = '') {
            this.isBanksLoaded = true;
            this.$store.dispatch(BANKS_SIMPLE_LIST, { q: query }).then((data) => {
                const banks = data && data.records && data.records.banksList
                    ? data.records.banksList
                    : [];
                this.banksFilter = banks;
                this.ensureBankOptionForPrefill(this.editedItem.bank_name);
                this.isBanksLoaded = false;
            }).catch(() => {
                this.isBanksLoaded = false;
            });
        },
        ensureBankOptionForPrefill(bankName) {
            if (!bankName) {
                return;
            }

            const exists = this.banksFilter.some((bank) => bank.full_name === bankName);
            if (!exists) {
                this.banksFilter = [{ id: 0, full_name: bankName }, ...this.banksFilter];
            }
        },
        resetReservationForm(resetForm = true) {
            this.editedItem = {};
            this.ownersFilter = [];
            this.ownersSearch = '';
            this.banksFilter = [];
            this.isOwnersLoaded = false;
            this.isBanksLoaded = false;
            this.displaySalePrice = '';
            if (!resetForm) {
                return;
            }
            this.$nextTick(() => {
                if (this.$refs.ru_form) {
                    this.$refs.ru_form.reset();
                    this.$refs.ru_form.resetValidation();
                }
            });
        },
        initializeReserveForm() {
            this.resetReservationForm();
            this.$nextTick(() => {
                this.applySalePriceFromItem();
            });
        },
        applySalePriceFromItem() {
            const candidates = [
                this.item.reserve_sale_price,
                this.item.max_sale_price,
                this.item.min_sale_price,
                this.item.max_price_temp,
            ];

            for (const candidate of candidates) {
                if (!this.isValidListingPrice(candidate)) {
                    continue;
                }

                if (typeof candidate === 'string' && candidate.includes(',')) {
                    this.displaySalePrice = candidate;
                } else {
                    this.displaySalePrice = this.formatListingPriceForDisplay(candidate);
                }

                return;
            }

            this.displaySalePrice = 'N/A';
        },
        applySalePriceFromReservation() {
            const reservation = this.item.latest_book || this.item.latest_reserve;
            if (!reservation || !reservation.sale_price) {
                return;
            }

            const formatted = this.formatListingPriceForDisplay(reservation.sale_price);
            if (formatted !== 'N/A') {
                this.displaySalePrice = formatted;
            }
        },
        initializeBookForm() {
            this.resetReservationForm(false);
            this.$nextTick(() => {
                this.applySalePriceFromItem();
                this.applySalePriceFromReservation();
                this.prefillFromLatestReservation();
                this.applyDefaultPaymentPlanFromListing();
                this.$nextTick(() => {
                    if (this.$refs.ru_form) {
                        this.$refs.ru_form.resetValidation();
                    }
                });
            });
        },
        handleBookItemChange(newItem, oldItem) {
            if (!newItem || !newItem.id) {
                return;
            }

            if (!oldItem || !oldItem.id || newItem.id !== oldItem.id) {
                this.initializeBookForm();
                return;
            }

            const hadReserve = oldItem.latest_reserve;
            const hasReserve = newItem.latest_reserve;
            const ownersBecameAvailable = hasReserve
                && hasReserve.owner_contacts
                && hasReserve.owner_contacts.length
                && (!hadReserve || !hadReserve.owner_contacts || !hadReserve.owner_contacts.length);

            this.$nextTick(() => {
                this.applySalePriceFromItem();
                this.applySalePriceFromReservation();
                if (hasReserve && (
                    !hadReserve
                    || ownersBecameAvailable
                    || JSON.stringify(hadReserve) !== JSON.stringify(hasReserve)
                )) {
                    this.prefillFromLatestReservation();
                }
                this.applyDefaultPaymentPlanFromListing();
            });
        },
        handleReserveItemChange(newItem, oldItem) {
            if (!newItem || !newItem.id) {
                return;
            }

            if (!oldItem || !oldItem.id || newItem.id !== oldItem.id) {
                this.initializeReserveForm();
                return;
            }

            this.$nextTick(() => {
                this.applySalePriceFromItem();
            });
        },
        parseFormattedNumber(value) {
            if (value === null || value === undefined || value === '') {
                return 0;
            }
            if (typeof value === 'number') {
                return isNaN(value) ? 0 : value;
            }
            const normalized = String(value).replace(/[^0-9.]/g, '');
            const parsed = parseFloat(normalized);
            return isNaN(parsed) ? 0 : parsed;
        },
        formatReservationAmount(value) {
            const rounded = Math.round(this.parseFormattedNumber(value));
            return rounded > 0 ? this.addTSBV(String(rounded)) : '';
        },
        formatReservationPercentage(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            return String(Math.round(this.parseFormattedNumber(value)));
        },
        isWholeNumber(evt) {
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                return evt.preventDefault();
            }
            return true;
        },
        isValidListingPrice(value) {
            if (value === null || value === undefined || value === '') {
                return false;
            }
            if (value === '0' || value === '0.00') {
                return false;
            }

            return this.parseFormattedNumber(value) > 0;
        },
        formatListingPriceForDisplay(value) {
            if (typeof value === 'string' && value.includes(',')) {
                return value;
            }

            const amount = this.parseFormattedNumber(value);

            return amount > 0 ? this.addTSBV(String(amount)) : 'N/A';
        },
        stripNumeric(value) {
            if (value === null || value === undefined || value === '') {
                return '';
            }
            return String(value).replace(/,/g, '');
        },
        buildReservationPayload(ritem, type) {
            const payload = {
                ...ritem,
                type,
                sale_price: this.salePriceAmount || null,
                price: ritem.price ? String(Math.round(this.parseFormattedNumber(ritem.price))) : '',
                price_percentage: ritem.price_percentage ? String(Math.round(this.parseFormattedNumber(ritem.price_percentage))) : '',
                down_payment: this.stripNumeric(ritem.down_payment),
                remaining_payment: this.stripNumeric(ritem.remaining_payment),
                unit_blocking_amount: this.stripNumeric(ritem.unit_blocking_amount),
                payment_plan_id: ritem.payment_plan_id || null,
            };

            if (!this.isChequePayment) {
                payload.cheque_number = null;
                payload.bank_name = null;
                payload.cheque_date = null;
                payload.is_cashable = null;
            }

            return payload;
        },
        onReservationAmountInput() {
            if (this.syncingReservationPricing) {
                return;
            }
            this.$nextTick(() => {
                const salePrice = this.salePriceAmount;
                const amount = this.parseFormattedNumber(this.editedItem.price);
                if (!salePrice || isNaN(amount)) {
                    return;
                }
                this.syncingReservationPricing = true;
                this.editedItem.price = this.formatReservationAmount(amount);
                this.editedItem.price_percentage = this.formatReservationPercentage((amount / salePrice) * 100);
                this.syncingReservationPricing = false;
            });
        },
        onReservationPercentInput(inputValue) {
            if (this.syncingReservationPricing) {
                return;
            }
            this.$nextTick(() => {
                const salePrice = this.salePriceAmount;
                const percentageSource = inputValue !== undefined && inputValue !== null
                    ? inputValue
                    : this.editedItem.price_percentage;
                const percentage = this.parseFormattedNumber(percentageSource);
                if (!salePrice || isNaN(percentage)) {
                    return;
                }
                this.syncingReservationPricing = true;
                this.editedItem.price = this.formatReservationAmount((percentage / 100) * salePrice);
                this.syncingReservationPricing = false;
            });
        },
        resolveReservationOwnerIds(reservation) {
            let ids = [];

            if (Array.isArray(reservation.owner_ids) && reservation.owner_ids.length) {
                ids = reservation.owner_ids;
            } else if (reservation.owners) {
                try {
                    const parsed = typeof reservation.owners === 'string'
                        ? JSON.parse(reservation.owners)
                        : reservation.owners;
                    if (Array.isArray(parsed)) {
                        ids = parsed;
                    }
                } catch (error) {
                    ids = [];
                }
            }

            return ids
                .map(id => Number(id))
                .filter(id => !isNaN(id) && id > 0);
        },
        mergeOwnerContacts(...groups) {
            const contactsById = new Map();

            groups.flat().forEach((contact) => {
                if (!contact || contact.id === null || contact.id === undefined) {
                    return;
                }

                const id = Number(contact.id);
                contactsById.set(id, {
                    ...contactsById.get(id),
                    ...contact,
                    id,
                });
            });

            return Array.from(contactsById.values());
        },
        getSelectedOwnerContacts() {
            const ownerIds = Array.isArray(this.editedItem.owner_ids) ? this.editedItem.owner_ids : [];
            if (!ownerIds.length) {
                return [];
            }

            const normalizedIds = ownerIds.map((id) => Number(id));
            return this.ownersFilter.filter((contact) => normalizedIds.includes(Number(contact.id)));
        },
        onOwnersSelectionChange() {
            this.ownersSearch = '';
        },
        ownersFilterKeyUp(e) {
            clearTimeout(this.apiTimeout);
            const that = this;
            this.apiTimeout = setTimeout(function () {
                if (e.target.value.length >= 3) {
                    that.loadOwnersList(e.target.value);
                }
            }, 900);
        },
        preloadOwnersFilter() {
            if (this.readonly) {
                return;
            }

            if (this.ownersFilter.length > 0) {
                return;
            }

            this.loadOwnersList('');
        },
        loadOwnersList(query) {
            const selectedContacts = this.getSelectedOwnerContacts();
            this.isOwnersLoaded = true;
            this.$store
                .dispatch(CONTACTS_SIMPLE_LIST, {
                    role: 'Real Estate Owners',
                    q: query || '',
                })
                .then((data) => {
                    const fetched = data.records && data.records.contactsList
                        ? data.records.contactsList
                        : [];
                    this.ownersFilter = this.mergeOwnerContacts(fetched, selectedContacts);
                    this.isOwnersLoaded = false;
                })
                .catch(() => {
                    this.ownersFilter = selectedContacts;
                    this.isOwnersLoaded = false;
                });
        },
        buildOwnersFilterForIds(ownerIds, reservation) {
            const normalizedIds = ownerIds.map(id => Number(id));
            const contacts = [];

            if (reservation.owner_contacts && reservation.owner_contacts.length) {
                contacts.push(...reservation.owner_contacts);
            }

            if (this.item.owners && this.item.owners.length) {
                contacts.push(...this.item.owners.filter((owner) => normalizedIds.includes(Number(owner.id))));
            }

            return this.mergeOwnerContacts(contacts);
        },
        ownersNeedDetailedFetch(contacts, ownerIds) {
            if (!ownerIds.length) {
                return false;
            }

            if (!contacts.length) {
                return true;
            }

            return contacts.some((contact) => {
                const missingDetails = contact.contact_phone_titles === undefined
                    && contact.contact_email_titles === undefined;
                const placeholderName = String(contact.full_name || '').startsWith('Contact #');

                return missingDetails || placeholderName;
            });
        },
        loadOwnersForIds(ownerIds, existingContacts = []) {
            this.isOwnersLoaded = true;
            this.$store.dispatch(CONTACTS_SIMPLE_LIST, {
                role: 'Real Estate Owners',
                q: '',
                ids: ownerIds,
            }).then((data) => {
                const fetched = data && data.records && data.records.contactsList
                    ? data.records.contactsList
                    : [];
                this.ownersFilter = this.mergeOwnerContacts(fetched, existingContacts);
                this.$set(this.editedItem, 'owner_ids', ownerIds);
                this.isOwnersLoaded = false;
            }).catch(() => {
                this.ownersFilter = existingContacts;
                this.$set(this.editedItem, 'owner_ids', ownerIds);
                this.isOwnersLoaded = false;
            });
        },
        applyOwnersToForm(ownerIds, reservation) {
            const ownersFilter = this.buildOwnersFilterForIds(ownerIds, reservation);

            if (!ownerIds.length) {
                this.ownersFilter = [];
                this.$set(this.editedItem, 'owner_ids', []);
                return;
            }

            if (this.ownersNeedDetailedFetch(ownersFilter, ownerIds)) {
                this.loadOwnersForIds(ownerIds, ownersFilter);
                return;
            }

            this.ownersFilter = ownersFilter;
            this.$set(this.editedItem, 'owner_ids', ownerIds);
        },
        prefillFromLatestReservation() {
            const reservation = this.item.latest_reserve;
            this.prefillFromReservation(reservation);
        },
        applyDefaultPaymentPlanFromListing() {
            if (this.editedItem.payment_plan_id) {
                return;
            }

            const reservation = this.item.latest_reserve;
            if (reservation && reservation.listing_payment_plan_id) {
                this.$set(this.editedItem, 'payment_plan_id', reservation.listing_payment_plan_id);
                return;
            }

            const plans = this.item.payment_plans || [];
            if (plans.length > 0) {
                this.$set(this.editedItem, 'payment_plan_id', plans[0].id);
            }
        },
        prefillFromReservation(reservation) {
            if (!reservation) {
                return;
            }

            const ownerIds = this.resolveReservationOwnerIds(reservation);
            const modeOfPayment = reservation.mode_of_payment !== null && reservation.mode_of_payment !== undefined
                ? Number(reservation.mode_of_payment)
                : null;

            this.applyOwnersToForm(ownerIds, reservation);
            this.$set(this.editedItem, 'payment_plan_id', reservation.listing_payment_plan_id || null);
            this.$set(this.editedItem, 'price', reservation.price ? this.formatReservationAmount(reservation.price) : '');
            this.$set(this.editedItem, 'unit_blocking_amount', reservation.unit_blocking_amount
                ? this.formatReservationAmount(reservation.unit_blocking_amount)
                : '');
            this.$set(this.editedItem, 'price_percentage', reservation.price_percentage
                ? this.formatReservationPercentage(reservation.price_percentage)
                : '');
            this.$set(this.editedItem, 'down_payment', reservation.down_payment
                ? this.formatReservationAmount(reservation.down_payment)
                : '');
            this.$set(this.editedItem, 'remaining_payment', reservation.remaining_payment
                ? this.formatReservationAmount(reservation.remaining_payment)
                : '');
            this.$set(this.editedItem, 'mode_of_payment', modeOfPayment);

            if (modeOfPayment === 2) {
                this.$set(this.editedItem, 'cheque_number', reservation.cheque_number || '');
                this.$set(this.editedItem, 'bank_name', reservation.bank_name || '');
                this.$set(this.editedItem, 'cheque_date', reservation.cheque_date
                    ? String(reservation.cheque_date).substring(0, 10)
                    : '');
                this.$set(this.editedItem, 'is_cashable', reservation.is_cashable === 0 || reservation.is_cashable === 1
                    ? reservation.is_cashable
                    : null);
                this.loadBanksList(reservation.bank_name || '');
            } else {
                this.clearChequeFields();
            }
        },
        initializeViewForm() {
            this.resetReservationForm(false);
            this.$nextTick(() => {
                this.applySalePriceFromItem();
                this.applySalePriceFromReservation();
                const reservation = this.item.latest_book || this.item.latest_reserve;
                if (reservation && reservation.sale_price) {
                    const formatted = this.formatListingPriceForDisplay(reservation.sale_price);
                    if (formatted !== 'N/A') {
                        this.displaySalePrice = formatted;
                    }
                }
                this.prefillFromReservation(reservation);
                this.$nextTick(() => {
                    if (this.$refs.ru_form) {
                        this.$refs.ru_form.resetValidation();
                    }
                });
            });
        },
        handleViewItemChange(newItem, oldItem) {
            if (!newItem || !newItem.id) {
                return;
            }

            if (!oldItem || !oldItem.id || newItem.id !== oldItem.id) {
                this.initializeViewForm();
                return;
            }

            this.$nextTick(() => {
                this.applySalePriceFromItem();
                const reservation = newItem.latest_book || newItem.latest_reserve;
                if (reservation) {
                    this.prefillFromReservation(reservation);
                }
            });
        },
    },
};
